import React from 'react';
import "./css/CustomSweetAlert.css";
const CustomSweetAlert = ({ 
  show, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = "OK",
  cancelText = "Cancel",
  type = "warning" 
}) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return '⚠️';
    }
  };

  const getAlertClass = () => {
    switch (type) {
      case 'success': return 'sweet-alert-success';
      case 'error': return 'sweet-alert-error';
      case 'warning': return 'sweet-alert-warning';
      case 'info': return 'sweet-alert-info';
      default: return 'sweet-alert-warning';
    }
  };

  return (
    <div className="sweet-alert-overlay">
      <div className={`sweet-alert ${getAlertClass()}`}>
        <div className="sweet-alert-content">
          <h3 className="sweet-alert-title">{title}</h3>
          <p className="sweet-alert-message">{message}</p>
        </div>
        <div className="sweet-alert-buttons">
          {onCancel && (
            <button 
              className="sweet-alert-btn sweet-alert-cancel"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button 
            className="sweet-alert-btn sweet-alert-confirm"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomSweetAlert;